export const setError = error => (dispatch, getState) => {
    dispatch({ type: 'SET_ERROR', error })
}
